import './styles.scoped.css'
import {useEffect} from 'react'
import {useMobile} from '../../hooks'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {Typography, IconButton, Button} from '@mui/material'
import {Menu, ChevronLeft, ChevronRight, Refresh} from '@mui/icons-material'
import {NotificationIcon} from '../../components'
import {NeedsYourAttention, QuickActions, OrganizationAtGlance, TodaysScheduleOverview} from './components'
import {format, addDays} from 'date-fns'

export default () => {
    const {mobile} = useMobile()
    const {setMobileSidebar, dashboardDate, setDashboardDate, setDashboardRefresh} = useGlobalStates()

    useEffect(() => {
        if (mobile) {
            setMobileSidebar(false)
        }
    }, [])

    const prevDate = () => setDashboardDate(prev => addDays(prev, -1))

    const nextDate = () => setDashboardDate(prev => addDays(prev, 1))

    const refresh = () => setDashboardRefresh(new Date())

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <div className="title">
                            <IconButton onClick={() => setMobileSidebar(true)}>
                                <Menu />
                            </IconButton>
                            <Typography variant="h6" color="text.primary">
                                Dashboard
                            </Typography>
                        </div>
                        <NotificationIcon />
                    </div>
                    <br />
                    <br />
                    <div className="form">
                        <IconButton onClick={prevDate} size="large">
                            <ChevronLeft />
                        </IconButton>
                        <Typography variant="h8" color="text.primary">
                            {format(dashboardDate, 'd MMMM yyyy')}
                        </Typography>
                        <IconButton onClick={nextDate} size="large">
                            <ChevronRight />
                        </IconButton>
                        <Button variant="contained" startIcon={<Refresh />} onClick={refresh}>
                            Refresh
                        </Button>
                    </div>
                </>
            ) : (
                <div className="header">
                    <Typography variant="h5" color="text.primary">
                        Dashboard
                    </Typography>
                    <div className="form">
                        <IconButton onClick={prevDate} size="large">
                            <ChevronLeft />
                        </IconButton>
                        <Typography variant="h8" color="text.primary">
                            {format(dashboardDate, 'd MMMM yyyy')}
                        </Typography>
                        <IconButton onClick={nextDate} size="large">
                            <ChevronRight />
                        </IconButton>
                        <Button variant="contained" startIcon={<Refresh />} onClick={refresh}>
                            Refresh
                        </Button>
                    </div>
                </div>
            )}
            <br />
            <NeedsYourAttention />
            <br />
            <br />
            <Typography variant="overline" color="text.primary" style={{fontWeight: 700}}>
                Quick Actions
            </Typography>
            <br />
            <br />
            <QuickActions />
            <br />
            <br />
            <Typography variant="overline" color="text.primary" style={{fontWeight: 700}}>
                Organization at a Glance
            </Typography>
            <br />
            <br />
            <OrganizationAtGlance />
            <br />
            <br />
            <TodaysScheduleOverview />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </>
    )
}
